import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter
} from '@reduxjs/toolkit'
import { client } from '../../api/client'

const singleVarAdapter = createEntityAdapter({
    selectId: singleVar => singleVar.Id
})

const initialState = singleVarAdapter.getInitialState({
    status: 'idle',
    error: null,
    toggleAttachmentView: {},
    toggleBatchPackingsView: false,
    VarBatchPackingsFormId: null,
    //toggleDiluentView: false,
    //dropperId: null,
    editVarId: null
})

export const fetchVar = createAsyncThunk('var/Get', async (varId) => {
    const response = await client.get('/VarTransactions/GetVarTransaction/' + varId)
    return response.data
})

export const varUpdated = createAsyncThunk(
    'var/Update',
    async (Id, { getState, /*requestId*/ }) => {
        const { entities } = getState().singleVar
        var now = new Date()
        const response = await client.post('/VarTransactions/Update?nowClient=' + now.toISOString().substring(0, 11) + now.toTimeString().substring(0, 8), entities[Id])
        return response.data
    }
)

const singleVarSlice = createSlice({
    name: 'singleVar',
    initialState,
    reducers: {
        Reload(state) {
            if (state.editVarId !== null) return
            singleVarAdapter.removeAll(state)
            state.status = 'idle'
            state.error = null
        },
        setEditVarId(state, action) {
            const { varId } = action.payload
            state.editVarId = varId
        },
        addAttachment(state, action) {
            const { VarTransactionId } = action.payload
            state.entities[VarTransactionId].VarAttachments.push(action.payload)
            //console.log("add attachment", action.payload, state.entities[VarTransactionId].VarAttachments)
        },
        deleteAttachment(state, action) {
            const { VarTransactionId, Id } = action.payload
            state.entities[VarTransactionId].VarAttachments.forEach((item, index) => {
                if (item.Id === Id)
                    state.entities[VarTransactionId].VarAttachments.splice(index, 1)
            })
            //console.log("delete attachment", action.payload)
        },
        toggleAttachmentView(state, action) {
            //console.log("toggle attachment 1", action.payload, state.toggleAttachmentView)
            //console.log(state.toggleAttachmentView[VarFieldAttachmentId], "var attach filed?")
            const { AttachmentId, VarFieldAttachmentId } = action.payload
            state.toggleAttachmentView[VarFieldAttachmentId] = !state.toggleAttachmentView[VarFieldAttachmentId]
            state.AttachmentId = AttachmentId
            state.VarFieldAttachmentId = VarFieldAttachmentId
            //console.log("toggle attachment 2", action.payload, state.toggleAttachmentView)
        },
        addVarBatchPackings(state, action) {
            const { VarTransactionId } = action.payload
            state.entities[VarTransactionId].VarBatchPackings.push(action.payload)
        },
        updateVarBatchPackings(state, action) {
            const { Id, BatchNumber, Quantity, ExpiryDate, VarTransactionId } = action.payload
            let batchPackings = state.entities[VarTransactionId].VarBatchPackings.find(x => x.Id === Id)
            batchPackings.BatchNumber = BatchNumber
            batchPackings.Quantity = Quantity
            batchPackings.ExpiryDate = ExpiryDate
        },
        deleteBatchPackings(state, action) {
            const { VarTransactionId, Id } = action.payload
            state.entities[VarTransactionId].VarBatchPackings.forEach((item, index) => {
                if (item.Id === Id)
                    state.entities[VarTransactionId].VarBatchPackings.splice(index, 1)
            })
        },
        toggleBatchPackingsView(state, action) {
            const { VarBatchPackingsFormId } = action.payload
            state.toggleBatchPackingsView = !state.toggleBatchPackingsView
            state.VarBatchPackingsFormId = VarBatchPackingsFormId
            //console.log("toggle VarBatchPackings View", action.payload, state.toggleBatchPackingsView)
        },
        //addPhoto(state, action) {
        //    const { VarTransactionId } = action.payload
        //    state.entities[VarTransactionId].VarAttachments.push(action.payload)
        //},
        //deletePhoto(state, action) {
        //    const { VarTransactionId, Id } = action.payload
        //    state.entities[VarTransactionId].VarAttachments.forEach((item, index) => {
        //        if (item.Id === Id)
        //            state.entities[VarTransactionId].VarAttachments.splice(index, 1)
        //    })
        //},
        //togglePhotoView(state, action) {
        //    const { photoId } = action.payload
        //    state.togglePhotoView = !state.togglePhotoView
        //    state.photoId = photoId
        //},
        updateIsAllAboveInformationCorrect(state, action) {
            const { VarTransactionId, IsAllAboveInformationCorrect, AirportOfDestinationIncorrect, AirportOfDestinationCorrected, PonoIncorrect, PonoCorrected,
                    AwbNoIncorrect, AwbNoCorrected, DeliveryInformationIncorrect, AllAboveInformationCorrectComment } = action.payload
            let varx = state.entities[VarTransactionId];
            varx.IsAllAboveInformationCorrect = IsAllAboveInformationCorrect
            if (varx.IsAllAboveInformationCorrect == false) {
                varx.AllAboveInformationCorrectComment = AllAboveInformationCorrectComment
                varx.AirportOfDestinationIncorrect = AirportOfDestinationIncorrect
                varx.AirportOfDestinationCorrected = AirportOfDestinationCorrected
                varx.PonoIncorrect = PonoIncorrect
                varx.PonoCorrected = PonoCorrected
                varx.AwbNoIncorrect = AwbNoIncorrect
                varx.AwbNoCorrected = AwbNoCorrected
                varx.DeliveryInformationIncorrect = DeliveryInformationIncorrect
            }
            else {
                varx.AllAboveInformationCorrectComment = null
                varx.AirportOfDestinationIncorrect = null
                varx.AirportOfDestinationCorrected = null
                varx.PonoIncorrect = null
                varx.PonoCorrected = null
                varx.AwbNoIncorrect = null
                varx.AwbNoCorrected = null
                varx.DeliveryInformationIncorrect = null
            }
            //console.log("1- update varx " + JSON.stringify(action.payload) + " , " + varx.AllAboveInformationCorrectComment)
        },
        updateVarPoLine(state, action) {
            const { Id, DeliveryQuantityCorrected, UpdatedServerDate, VarTransactionId } = action.payload
            let varPoLine = state.entities[VarTransactionId].VarPoLines.find(x => x.Id === Id)
            varPoLine.DeliveryQuantityCorrected = DeliveryQuantityCorrected
            varPoLine.UpdatedServerDate = UpdatedServerDate
            //console.log("1- update Var po line id " + Id, varPoLine.DeliveryQuantity)
        },
        updateIsShipmentInfoGood(state, action) {
            const { VarTransactionId, IsShipmentInfoGood } = action.payload
            let varx = state.entities[VarTransactionId];
            varx.IsShipmentInfoGood = IsShipmentInfoGood
            //console.log("2- update IsShipmentInfoGood varx " + JSON.stringify(action.payload))
        },
        updateIsPreAdviceReceivedInTime(state, action) {
            const { VarTransactionId, IsPreAdviceReceivedInTime, DaysPassedBetweenReceiptAndShipment } = action.payload
            let varx = state.entities[VarTransactionId];
            varx.IsPreAdviceReceivedInTime = IsPreAdviceReceivedInTime
            if (varx.IsPreAdviceReceivedInTime == false)
                varx.DaysPassedBetweenReceiptAndShipment = DaysPassedBetweenReceiptAndShipment
            else
                varx.DaysPassedBetweenReceiptAndShipment = null
            //console.log("3- update IsPreAdviceReceivedInTime varx " + JSON.stringify(action.payload))
        },
        updateIsPreAdviceWithAllDocs(state, action) {
            const { VarTransactionId, IsPreAdviceWithAllDocs, PreAdviceInvoice, PreAdvicePackingList, PreAdviceBatchCertificate, PreAdviceCertificateOfOrigin, PreAdviceCertificateOfConformity, PreAdviceCertificateOfAnalysis, PreAdviceOtherCertificate, PreAdviceAdditionalComments } = action.payload
            let varx = state.entities[VarTransactionId];
            varx.IsPreAdviceWithAllDocs = IsPreAdviceWithAllDocs
            if (varx.IsPreAdviceWithAllDocs == false) {
                varx.PreAdviceInvoice = PreAdviceInvoice
                varx.PreAdvicePackingList = PreAdvicePackingList
                varx.PreAdviceBatchCertificate = PreAdviceBatchCertificate
                varx.PreAdviceCertificateOfOrigin = PreAdviceCertificateOfOrigin
                varx.PreAdviceCertificateOfConformity = PreAdviceCertificateOfConformity
                varx.PreAdviceCertificateOfAnalysis = PreAdviceCertificateOfAnalysis
                varx.PreAdviceOtherCertificate = PreAdviceOtherCertificate
                varx.PreAdviceAdditionalComments = PreAdviceAdditionalComments
            }
            else {
                varx.PreAdviceInvoice = null
                varx.PreAdvicePackingList = null
                varx.PreAdviceBatchCertificate = null
                varx.PreAdviceCertificateOfOrigin = null
                varx.PreAdviceCertificateOfConformity = null
                varx.PreAdviceCertificateOfAnalysis = null
                varx.PreAdviceOtherCertificate = null
                varx.PreAdviceAdditionalComments =  null
            }
            //console.log("4- update IsPreAdviceWithAllDocs varx " + JSON.stringify(action.payload))
        },
        updateIsFlightArrivedOnTime(state, action) {
            const { VarTransactionId, IsFlightArrivedOnTime, ActualDateOfArrival } = action.payload
            let varx = state.entities[VarTransactionId];
            varx.IsFlightArrivedOnTime = IsFlightArrivedOnTime
            if (varx.IsFlightArrivedOnTime == false)
                varx.ActualDateOfArrival = ActualDateOfArrival
            else
                varx.ActualDateOfArrival = null
            //console.log("5- update IsFlightArrivedOnTime varx " + JSON.stringify(action.payload))
        },
        updateIsAtDeliveryReceivedAllRequiredDocuments(state, action) {
            const { VarTransactionId, IsAtDeliveryReceivedAllRequiredDocuments, Invoice, PackingList, ReleaseCertificate, CertificateOfOrigin, CertificateOfConformity, CertificateOfAnalysis, OtherCertificate, ShipmentDocumentComments } = action.payload
            let varx = state.entities[VarTransactionId];
            varx.IsAtDeliveryReceivedAllRequiredDocuments = IsAtDeliveryReceivedAllRequiredDocuments
            if (varx.IsAtDeliveryReceivedAllRequiredDocuments == false) {
                varx.Invoice = Invoice
                varx.PackingList = PackingList
                varx.ReleaseCertificate = ReleaseCertificate
                varx.CertificateOfOrigin = CertificateOfOrigin
                varx.CertificateOfConformity = CertificateOfConformity
                varx.CertificateOfAnalysis = CertificateOfAnalysis
                varx.OtherCertificate = OtherCertificate
                varx.ShipmentDocumentComments = ShipmentDocumentComments
            }
            else {
                varx.Invoice = null
                varx.PackingList = null
                varx.ReleaseCertificate = null
                varx.CertificateOfOrigin = null
                varx.CertificateOfConformity = null
                varx.CertificateOfAnalysis = null
                varx.OtherCertificate = null
                varx.ShipmentDocumentComments = null
            }
            //console.log("6- update IsAtDeliveryReceivedAllRequiredDocuments varx " + JSON.stringify(action.payload))
        },
        updateIsBatchesMatchedWithPackingList(state, action) {
            const { VarTransactionId, IsBatchesMatchedWithPackingList, BatchesMatchedWithPackingListComment } = action.payload
            let varx = state.entities[VarTransactionId]
            varx.IsBatchesMatchedWithPackingList = IsBatchesMatchedWithPackingList
            if (varx.IsBatchesMatchedWithPackingList == false)
                varx.BatchesMatchedWithPackingListComment = BatchesMatchedWithPackingListComment
            else
                varx.BatchesMatchedWithPackingListComment = null
            //console.log("7- update IsBatchesMatchedWithPackingList varx " + JSON.stringify(action.payload))
        },
        updateGoodConditionOfBoxesOnArrival(state, action) {
            const { VarTransactionId, GoodConditionOfBoxesOnArrival, GoodConditionOfBoxesOnArrivalComment } = action.payload
            let varx = state.entities[VarTransactionId]
            varx.GoodConditionOfBoxesOnArrival = GoodConditionOfBoxesOnArrival
            if (varx.GoodConditionOfBoxesOnArrival == false)
                varx.GoodConditionOfBoxesOnArrivalComment = GoodConditionOfBoxesOnArrivalComment
            else
                varx.GoodConditionOfBoxesOnArrivalComment = null
            //images
            //console.log("8- update GoodConditionOfBoxesOnArrival varx " + JSON.stringify(action.payload))
        },
        updateLabelsAttachedToBoxes(state, action) {
            const { VarTransactionId, LabelsAttachedToBoxes, LabelsAttachedToBoxesComment } = action.payload
            let varx = state.entities[VarTransactionId]
            varx.LabelsAttachedToBoxes = LabelsAttachedToBoxes
            if (varx.LabelsAttachedToBoxes == false)
                varx.LabelsAttachedToBoxesComment = LabelsAttachedToBoxesComment
            else
                varx.LabelsAttachedToBoxesComment = null
            //images
            //console.log("9- update LabelsAttachedToBoxes varx " + JSON.stringify(action.payload))
        },
        updateIsAllShippingBoxesInspected(state, action) {
            const { VarTransactionId, IsAllShippingBoxesInspected } = action.payload
            let varx = state.entities[VarTransactionId]
            varx.IsAllShippingBoxesInspected = IsAllShippingBoxesInspected
            //console.log("10- update IsAllShippingBoxesInspected varx " + JSON.stringify(action.payload))
        },
        updateIsThereProblemsWithTemperature(state, action) {
            const { VarTransactionId, IsThereProblemsWithTemperature, DeviceIds, ThereProblemsWithTemperatureComment } = action.payload
            let varx = state.entities[VarTransactionId]
            varx.IsThereProblemsWithTemperature = IsThereProblemsWithTemperature
            if (varx.IsThereProblemsWithTemperature == true) {
                varx.DeviceIds = DeviceIds
                varx.ThereProblemsWithTemperatureComment = ThereProblemsWithTemperatureComment
            }
            else {
                varx.DeviceIds = null
                varx.ThereProblemsWithTemperatureComment = null
            }
            //console.log("11- update IsThereProblemsWithTemperature varx " + JSON.stringify(action.payload))
        },
        updateIsThereAlarmsOrExcursionsTemperature(state, action) {
            const { VarTransactionId, IsThereAlarmsOrExcursionsTemperature, ThereAlarmsOrExcursionsTemperatureComment, InsColdStoreArrivalDate, TemperatureAlarmShakeTestResults } = action.payload
            let varx = state.entities[VarTransactionId]
            varx.IsThereAlarmsOrExcursionsTemperature = IsThereAlarmsOrExcursionsTemperature
            if (varx.IsThereAlarmsOrExcursionsTemperature == true) {
                //pdf
                //attach alarm
                //images
                varx.ThereAlarmsOrExcursionsTemperatureComment = ThereAlarmsOrExcursionsTemperatureComment
                varx.InsColdStoreArrivalDate = InsColdStoreArrivalDate
                varx.TemperatureAlarmShakeTestResults = TemperatureAlarmShakeTestResults
            }
            else {
                varx.ThereAlarmsOrExcursionsTemperatureComment = null
                varx.InsColdStoreArrivalDate = null
                varx.TemperatureAlarmShakeTestResults = null
            }
            //console.log("12- update IsThereAlarmsOrExcursionsTemperature varx " + JSON.stringify(action.payload))
        },
        updateDateOfInspection(state, action) {
            const { VarTransactionId, DateOfInspection } = action.payload
            let varx = state.entities[VarTransactionId]
            varx.DateOfInspection = DateOfInspection
            //console.log("13- update DateOfInspection varx " + JSON.stringify(action.payload))
        },
        updateIsThereAnyAdditionalComments(state, action) {
            const { VarTransactionId, IsThereAnyAdditionalComments, OtherComments } = action.payload
            let varx = state.entities[VarTransactionId]
            varx.IsThereAnyAdditionalComments = IsThereAnyAdditionalComments
            if (varx.IsThereAnyAdditionalComments == true)
                varx.OtherComments = OtherComments
            else
                varx.OtherComments = null
            //console.log("14- update IsThereAnyAdditionalComments varx " + JSON.stringify(action.payload))
        },
        updateAuthorizedSupervisor(state, action) {
            const { VarTransactionId, SupervisorId, ReasonForReferBack } = action.payload
            let varx = state.entities[VarTransactionId];
            varx.SupervisorId = SupervisorId
            varx.ReasonForReferBack = ReasonForReferBack
            //console.log("updateAuthorizedSupervisor slice ref com", ReasonForReferBack, SupervisorId)
        },
        updateVarStatus(state, action) {
            const { VarTransactionId, StatusId } = action.payload
            let varx = state.entities[VarTransactionId];
            varx.StatusId = StatusId
        },
    },
    extraReducers: {
        [fetchVar.pending]: (state, action) => {
            state.status = 'loading'
            state = undefined
        },
        [fetchVar.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            singleVarAdapter.addOne(state, action.payload)
        },
        [fetchVar.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload
        },
        [varUpdated.fulfilled]: (state, action) => {
            singleVarAdapter.updateOne(state, action.payload)
        },
    },
})

export default singleVarSlice.reducer

export const {
    Reload,
    setEditVarId,
    addAttachment,
    deleteAttachment,
    toggleAttachmentView,
    addVarBatchPackings,
    updateVarBatchPackings,
    deleteBatchPackings,
    toggleBatchPackingsView,
    updateIsAllAboveInformationCorrect,
    updateVarPoLine,
    updateIsShipmentInfoGood,
    updateIsPreAdviceReceivedInTime,
    updateIsPreAdviceWithAllDocs,
    updateIsFlightArrivedOnTime,
    updateIsAtDeliveryReceivedAllRequiredDocuments,
    updateIsBatchesMatchedWithPackingList,
    updateGoodConditionOfBoxesOnArrival,
    updateLabelsAttachedToBoxes,
    updateIsAllShippingBoxesInspected,
    updateIsThereProblemsWithTemperature,
    updateIsThereAlarmsOrExcursionsTemperature,
    updateDateOfInspection,
    updateIsThereAnyAdditionalComments,
    updateAuthorizedSupervisor,
    updateVarStatus
} = singleVarSlice.actions

export const {
    selectAll: selectAllVar,
    selectById: selectVarById,
} = singleVarAdapter.getSelectors((state) => state.singleVar)
